import { type OrganicStat, type UserDimension } from "../../../gql-generated/types";
import {
    mapAgeData,
    mapCountryFullName,
    mapInterestFullName,
    mapOsBreakdown,
    mapTopCountryMetrics,
} from "../../mapping";
import {
    type AgeStatsItem,
    type CountriesStatsItem,
    type InsightsMetrics,
    type OsStatsItem,
    createDefaultInsightsMetrics,
} from "../../models";

interface SortAudienceStats {
    ageStats: readonly OrganicStat[];
    osStats: readonly OrganicStat[];
    countryStats: readonly OrganicStat[];
    interestStats: readonly OrganicStat[];
    dimensionsFields: UserDimension[];
}

const FIRST_TOP_ITEMS = 10;

export const sortAndMapAudienceStats = ({
    ageStats,
    osStats,
    countryStats,
    interestStats,
}: SortAudienceStats): {
    ageGenderStats: AgeStatsItem<number>[];
    osMetrics: InsightsMetrics<OsStatsItem>;
    countryMetrics: InsightsMetrics<CountriesStatsItem>;
    interestMetrics: InsightsMetrics<CountriesStatsItem>;
} => {
    const ageGenderStats = mapAgeData(ageStats);

    const countryMetrics = createDefaultInsightsMetrics<CountriesStatsItem>();
    countryMetrics.stats = mapTopCountryMetrics(countryStats, FIRST_TOP_ITEMS, mapCountryFullName);

    const interestMetrics = createDefaultInsightsMetrics<CountriesStatsItem>();
    interestMetrics.stats = mapTopCountryMetrics(interestStats, FIRST_TOP_ITEMS, mapInterestFullName);

    const osMetrics = createDefaultInsightsMetrics<OsStatsItem>();
    osMetrics.stats = mapOsBreakdown(osStats);

    return { ageGenderStats, osMetrics, countryMetrics, interestMetrics };
};
